// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import wixLocation from 'wix-location';

$w.onReady(function () {
	let options = [];
	for (let i = 1; i<=50; i++)
	{
		let entry = {"label": i.toString(), "value": i.toString()};
		options.push(entry);
	}
	$w("#yearsDropdown1").options = options;
	$w("#yearsDropdown2").options = options;
	$w("#yearsDropdown3").options = options;
});

let performanceArray1 = []; let yearCount1 = 1; let submission1 = "";
let performanceArray2 = []; let yearCount2 = 1; let submission2 = "";
let performanceArray3 = []; let yearCount3 = 1; let submission3 = "";

export function addYearButton1_click(event) 
{
	let checker = false;
	let input = Number($w("#yearEntry1").value);
	 performanceArray1.push(input);
	 $w("#yearText1").text = "Year "+(yearCount1+1)+ ":"
	 $w("#yearEntry1").value = "";
	 submission1 = submission1 + "Y"+yearCount1+": "+input+ "% | "; 
	 $w("#submission1").text = submission1;
	 if (yearCount1 === Number($w("#yearsDropdown1").value))
	 {
		 performanceArray1String = performanceArray1.toString();
		 $w('#yearText1').text = "Complete";checker = true;
		 $w("#yearEntry1").disable();
		 $w("#addYearButton1").disable();
	 }
	  yearCount1++;
	  if ($w("#fundDropdown").value === "1" && checker === true)
	  {$w("#repeaterButton").enable();}
}

export function restartButton1_click(event) 
{
	performanceArray1 = []; yearCount1 = 0; submission1 = "";
	$w("#submission1").text = submission1;
	$w('#yearsDropdown1').value = undefined;
}

export function addYearButton2_click(event) 
{
	let checker = false;
	let input = Number($w("#yearEntry2").value);
	 performanceArray2.push(input);
	 $w("#yearText2").text = "Year "+(yearCount2+1)+ ":"
	 $w("#yearEntry2").value = "";
	 submission2 = submission2 + "Y"+yearCount2+": "+input+ "% | "; 
	 $w("#submission2").text = submission2;
	 if (yearCount2 === Number($w("#yearsDropdown2").value))
	 {
		performanceArray2String = performanceArray2.toString();
		$w('#yearText2').text = "Complete";checker = true;
		$w("#yearEntry2").disable();
		$w("#addYearButton2").disable();
	}
	yearCount2++;
	if ($w("#fundDropdown").value === "2" && checker === true)
	  {$w("#repeaterButton").enable();}
}

export function restartButton2_click(event) 
{
	performanceArray2 = []; yearCount2 = 0; submission2 = "";
	$w("#submission2").text = submission2;
	$w('#yearsDropdown2').value = undefined;
}

export function addYearButton3_click(event) 
{
	let checker = false;
	let input = Number($w("#yearEntry3").value);
	 performanceArray3.push(input);
	 $w("#yearText3").text = "Year "+(yearCount3+1)+ ":"
	 $w("#yearEntry3").value = "";
	 submission3 = submission3 + "Y"+yearCount3+": "+input+ "% | "; 
	 $w("#submission3").text = submission3;
	 if (yearCount3 === Number($w("#yearsDropdown3").value))
	 {
		 performanceArray3String = performanceArray3.toString();
		 $w('#yearText3').text = "Complete"; checker = true;
		 $w("#yearEntry3").disable();
		 $w("#addYearButton3").disable();
	 }
	yearCount3++;
	if ($w("#fundDropdown").value === "3" && checker === true)
	  {$w("#repeaterButton").enable();}
}

export function restartButton3_click(event) 
{
	performanceArray3 = []; yearCount3 = 0; submission3 = "";
	$w("#submission3").text = submission3;
	$w('#yearsDropdown3').value = undefined;
}

//key counters
export function descriptionBox_keyPress(event) {
	const remainingLength = $w('#descriptionBox').maxLength - $w('#descriptionBox').value.length;
    $w('#descriptionCount').text = `Only ${remainingLength} remaining characters.`; 
}

export function taglineBox_keyPress(event) {
	const remainingLength = $w('#taglineBox').maxLength - $w('#taglineBox').value.length;
    $w('#taglineCount').text = `Only ${remainingLength} remaining characters.`; 
}

export function fund1Description_keyPress(event) 
{
	const remainingLength = $w('#fundDescription1').maxLength - $w('#fundDescription1').value.length;
    $w('#fund1DescriptionCount').text = `Only ${remainingLength} remaining characters.`;
}

export function fundDropdown_change(event) 
{
	let selection = $w('#fundDropdown').value;

	if (selection === "1")
	{
		$w("#fundStrip1").expand();
	}
	if (selection === "2")
	{
		$w("#fundStrip1").expand();
		$w("#fundStrip2").expand();
	}
	if (selection === "3")
	{
		$w("#fundStrip1").expand();
		$w("#fundStrip2").expand();
		$w("#fundStrip3").expand();
	}
}

export function yesInfo_click(event) 
{
	$w("#yesInfo").disable();
	$w("#noInfo").disable();
	$w("#text518").expand();
	$w("#fundDropdown").expand(); 
	$w("#repeaterButton").expand();
	$w("#text554").expand(); 
	$w("#docUpload").expand();
}

export function noInfo_click(event) 
{
	$w("#yesInfo").disable();
	$w("#noInfo").disable();
	$w("#repeaterButton").expand(); $w("#repeaterButton").enable();
}

let xAxis = []; let spData = [];
export async function yearsDropdown3_change(event) 
{
	max = Math.max(Number($w("#yearsDropdown1").value),Number($w("#yearsDropdown2").value),Number($w("#yearsDropdown3").value)) 

	xAxis = []; spData = []; 
	let date = new Date();
	let year = date.getFullYear()-1;
	let yearCopy = date.getFullYear()-1;

	for (let i = 0; i<max; i++)
	{
		let input = year;
		xAxis.push(input);
		year--;
	}
	xAxisString = xAxis.toString();
	await wixData.query("sp500").gt("year", yearCopy-max)
  .find()
  .then((results) => 
  {
	  for(let i = 0; i <max; i++)
	  {
		  spData.push(results.items[i]['percentChange']);
	  }
		spDataString = spData.toString();  
	  
  }).catch( (err) => {
    let errorMsg = err;
  }); 
}

export async function yearsDropdown2_change(event) 
{
	max = Math.max(Number($w("#yearsDropdown1").value),Number($w("#yearsDropdown2").value),Number($w("#yearsDropdown3").value)) 

	xAxis = []; spData = [];
	let date = new Date();
	let year = date.getFullYear()-1;
	let yearCopy = date.getFullYear()-1;

	for (let i = 0; i<max; i++)
	{
		let input = year;
		xAxis.push(input);
		year--;
	}
	xAxisString = xAxis.toString();
	await wixData.query("sp500").gt("year", yearCopy-max)
  .find()
  .then((results) => 
  {
	  for(let i = 0; i <max; i++)
	  {
		  spData.push(results.items[i]['percentChange']);
	  }
		spDataString = spData.toString();   
  }).catch( (err) => {
    let errorMsg = err;
  });
}

export async function yearsDropdown1_change(event) 
{ 
	max = Math.max(Number($w("#yearsDropdown1").value),Number($w("#yearsDropdown2").value),Number($w("#yearsDropdown3").value)) 

	xAxis = []; spData = [];
	let date = new Date();
	let year = date.getFullYear()-1;
	let yearCopy = date.getFullYear()-1;

	for (let i = 0; i<max; i++)
	{
		let input = year;
		xAxis.push(input);
		year--;
	}
	xAxisString = xAxis.toString();
	await wixData.query("sp500").gt("year", yearCopy-max)
  .find()
  .then((results) => 
  {
	  for(let i = 0; i <max; i++)
	  {
		  spData.push(results.items[i]['percentChange']);
	  }
		spDataString = spData.toString();  
	  
  }).catch( (err) => {
    let errorMsg = err;
  });
}

//define global vars 

let performanceArray1String; let performanceArray2String; let performanceArray3String;
let max; let xAxisString; let spDataString;
let banner; let profile; let doc;

export function repeaterButton_click(event) {
	$w("#dataset1").onReady( () => {
    	$w("#dataset1").setFieldValues({
				"name": $w('#input2').value,
				"request":  $w('#checkboxGroup1').value.toString(),
				"crd":  $w('#input1').value,
				"email":  $w('#input3').value,
				"firmDescription":  $w('#descriptionBox').value,
				"firmTagline":  $w('#taglineBox').value,
				"firmSpecialties":  $w('#textBox2').value,
				"bannerImage":  banner,
				"profileImage": profile,
				"fundName1":  $w('#fundName1').value,
				"fundName2": $w('#fundName2').value,
				"fundName3": $w('#fundName3').value,
				"fundDescription1": $w('#fundDescription1').value,
				"fundDescription2": $w('#fundDescription2').value,
				"fundDescription3": $w('#fundDescription3').value,
				"fundFees1": $w('#fundFeeDescription1').value,
				"fundFees2": $w('#fundFeeDescription2').value,
				"fundFees3": $w('#fundFeeDescription3').value,
				"fundPerformance1": performanceArray1String,
				"fundPerformance2": performanceArray2String,
				"fundPerformance3": performanceArray3String,
				"fundBeta1": $w('#beta1').value,
				"fundBeta2": $w('#beta2').value,
				"fundBeta3": $w('#beta3').value,
				"fundYears1":  $w('#yearsDropdown1').value,
				"fundYears2": $w('#yearsDropdown2').value,
				"fundYears3": $w('#yearsDropdown3').value,
				"numberOfFunds": $w('#fundDropdown').value,
				"docUpload": doc,
				"yearsMax": max,
				"xAxisLabels": xAxisString,
				"spData": spDataString,

			})
			$w('#dataset1').save().then(()=>{
					wixLocation.to("https://www.financefriends.org/");
					$w("#text507").show();
			})
			})	
}

export function uploadButton1_change(event) {
	if($w("#uploadButton1").value.length > 0) {
    $w("#uploadButton1").startUpload()
      .then( (uploadedFile) => {
		  console.log(uploadedFile);
        banner = uploadedFile.url;
      })
      .catch( (uploadError) => {
      });
  } 
}

export function uploadButton2_change(event) {
	if($w("#uploadButton1").value.length > 0) {
    $w("#uploadButton1").startUpload()
      .then( (uploadedFile) => {
        profile = uploadedFile.url;
      })
      .catch( (uploadError) => {
      });
  } 
}

export function docUpload_change(event) {
	if($w("#uploadButton1").value.length > 0) {
    $w("#uploadButton1").startUpload()
      .then( (uploadedFile) => {
        doc = uploadedFile.url;
      })
      .catch( (uploadError) => {
      });
  } 
}